import { createContext, useContext } from 'react';
import type { AssistantMode } from '../../lib/harry/assistantMode';
import type { CornerAssistant } from '../../lib/harry/harryPrefs';

export interface HarryShellContextValue {
  panelOpen: boolean;
  setPanelOpen: (open: boolean) => void;
  togglePanel: () => void;
  /** Open the Navigator with a sentence already asked (from ⌘K). */
  openWith: (query: string) => void;
  /** The Navigator's voice: the workspace's guide, set in Settings → Agents. */
  voice: AssistantMode;
  cornerAssistant: CornerAssistant;
  setCornerAssistant: (corner: CornerAssistant) => void;
}

export const HarryShellContext = createContext<HarryShellContextValue | null>(null);

export function useHarryShell(): HarryShellContextValue {
  const ctx = useContext(HarryShellContext);
  if (!ctx) {
    throw new Error('useHarryShell must be used within HarryShell');
  }
  return ctx;
}

/** The shell when there is one; null outside it (the command palette's tests render it alone). */
export function useOptionalHarryShell(): HarryShellContextValue | null {
  return useContext(HarryShellContext);
}
